import { SITE_NAME, SITE_ORIGIN, SITE_LOGO } from './site';
import { SEO_CONTACT_FALLBACK, type SeoContactSettings } from './seo-settings';

export function localBusinessJsonLd(
  contact: SeoContactSettings = SEO_CONTACT_FALLBACK,
  extra?: Record<string, unknown>,
): string {
  return JSON.stringify(
    {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: SITE_NAME,
      url: SITE_ORIGIN,
      image: SITE_LOGO,
      telephone: contact.phone,
      email: contact.email,
      foundingDate: '1988',
      description:
        'Photographe mariage, production vidéo, photobooth et événements en Tunisie. Studio à Tunis et Djerba depuis 1988.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: contact.address,
        addressLocality: 'Tunis',
        addressCountry: 'TN',
      },
      openingHours: contact.workingHours,
      areaServed: 'Tunisie',
      ...(contact.sameAs.length ? { sameAs: contact.sameAs } : {}),
      ...extra,
    },
    null,
    2,
  );
}

export function servicePageJsonLd(name: string, description: string, path: string): string {
  return JSON.stringify(
    {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name,
      description,
      provider: {
        '@type': 'LocalBusiness',
        name: SITE_NAME,
        url: SITE_ORIGIN,
      },
      areaServed: {
        '@type': 'Country',
        name: 'Tunisia',
      },
      url: `${SITE_ORIGIN}${path === '/' ? '' : path}`,
    },
    null,
    2,
  );
}

export function faqPageJsonLd(faq: { q: string; a: string }[]): string {
  return JSON.stringify(
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faq.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.a,
        },
      })),
    },
    null,
    2,
  );
}

export type BreadcrumbItem = { name: string; path: string };

export function breadcrumbJsonLd(items: BreadcrumbItem[]): string {
  return JSON.stringify(
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: `${SITE_ORIGIN}${item.path === '/' ? '' : item.path}`,
      })),
    },
    null,
    2,
  );
}
